module.exports = __webpack_public_path__ + "static/media/IMG_20210705_113935_resized_20210705_120823626 (002)-min.e42fb49f.jpg";